/**
 * What a run spent against its token budget, from the AI gateway's record
 * of the run's own token (backend `run_usage_service.py`). The budget is
 * measured in fresh tokens -- uncached input, output and cache writes -- so
 * that is the number shown against it; cache reads are shown separately.
 */

import type { ReactElement } from 'react';
import type { RunUsage } from '../types/agentRun.types';

interface RunUsageSummaryProps {
  usage: RunUsage | null | undefined;
  budgetTokens: number;
}

export function RunUsageSummary({ usage, budgetTokens }: RunUsageSummaryProps): ReactElement {
  if (!usage) {
    return <dd>No model requests recorded · budget {budgetTokens.toLocaleString()} tokens</dd>;
  }
  const cost = usage.cost_usd === null ? null : `$${usage.cost_usd.toFixed(2)}`;
  return (
    <dd>
      {usage.budget_tokens_used.toLocaleString()} of {budgetTokens.toLocaleString()} tokens
      {' · '}
      {usage.requests.toLocaleString()} requests
      {usage.cache_read_tokens > 0 && ` · ${usage.cache_read_tokens.toLocaleString()} cached`}
      {cost !== null && ` · ${cost}`}
    </dd>
  );
}
